import { render, staticRenderFns } from "./LeapYearHeroSection.vue?vue&type=template&id=52e448b1&scoped=true&"
import script from "./LeapYearHeroSection.vue?vue&type=script&lang=js&"
export * from "./LeapYearHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./LeapYearHeroSection.vue?vue&type=style&index=0&id=52e448b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e448b1",
  null
  
)

export default component.exports